<lo-card heading="Brands">
	<button
		*ngIf="!loading && editingId !== newBrand"
		lo-button
		variant="link"
		size="sm"
		type="button"
		loCardActions
		(click)="startAdd()"
	>
		<lo-icon name="lo_plus"></lo-icon>
		Add brand
	</button>

	<p class="lo-type-text-sm brands__intro">
		The brands your campaigns can promote. The first is your account brand —
		the one you registered with. Ana uses the default one when a campaign
		does not name another.
	</p>

	<div class="brands" *ngIf="loading">
		<lo-skeleton variant="text" width="60%"></lo-skeleton>
		<lo-skeleton variant="text" width="40%"></lo-skeleton>
	</div>

	<div class="brands" *ngIf="!loading">
		<div class="brands__new" *ngIf="editingId === newBrand">
			<app-brand-profile-form
				saveLabel="Add brand"
				(saved)="onSaved($event)"
				(cancelled)="cancelEdit()"
			></app-brand-profile-form>
		</div>

		<p
			class="lo-type-text-sm brands__empty"
			*ngIf="!rows.length && editingId !== newBrand"
		>
			No brands yet.
		</p>

		<div
			class="brands__row"
			*ngFor="let row of rows; trackBy: trackById"
			[attr.data-brand-id]="row.brand.id"
		>
			<ng-container *ngIf="editingId !== row.brand.id">
				<img
					*ngIf="row.logo"
					class="brands__logo"
					alt="Brand logo"
					[src]="row.logo"
				/>
				<div
					class="brands__head"
					[class.ana-setting-room]="row.isAccount"
					[anaSetting]="row.isAccount ? 'profile.company_name' : ''"
				>
					<span class="lo-type-text-md-semibold">
						{{ row.brand.brand_name }}
					</span>
					<lo-status tone="info" *ngIf="row.brand.is_default">
						Default
					</lo-status>
					<lo-status tone="neutral">{{ row.sourceLabel }}</lo-status>
				</div>
				<span
					class="lo-type-text-sm brands__muted"
					*ngIf="row.website || row.isAccount"
					[class.ana-setting-room]="row.isAccount"
					[anaSetting]="row.isAccount ? 'profile.website' : ''"
				>
					{{ row.website || 'No website yet' }}
				</span>
				<p
					class="lo-type-text-sm brands__description"
					*ngIf="row.brand.brand_details_summary"
				>
					{{ row.brand.brand_details_summary }}
				</p>
				<span class="lo-type-text-sm brands__muted" *ngIf="row.socials">
					{{ row.socials }}
				</span>
				<p
					class="lo-type-text-sm brands__muted brands__note"
					*ngIf="row.isAccount && !canEditAccountBrand"
				>
					This is the account's brand identity. Only the account owner
					can change it.
				</p>

				<div
					class="brands__confirm"
					*ngIf="confirmRemoveId === row.brand.id"
				>
					<span class="lo-type-text-sm">
						Remove {{ row.brand.brand_name }}? Campaigns that
						promote it go back to your account brand.
					</span>
					<button
						lo-button
						variant="secondary"
						size="sm"
						type="button"
						(click)="cancelRemove()"
					>
						Keep
					</button>
					<button
						lo-button
						variant="danger"
						size="sm"
						type="button"
						[loading]="busyId === row.brand.id"
						(click)="remove(row)"
					>
						Remove
					</button>
				</div>

				<div
					class="brands__actions"
					*ngIf="confirmRemoveId !== row.brand.id"
				>
					<button
						*ngIf="row.editable"
						lo-button
						variant="link"
						size="sm"
						type="button"
						(click)="startEdit(row)"
					>
						<lo-icon name="pencil"></lo-icon>
						Edit
					</button>
					<button
						*ngIf="row.defaultable"
						lo-button
						variant="link"
						size="sm"
						type="button"
						[loading]="busyId === row.brand.id"
						(click)="makeDefault(row)"
					>
						Make default
					</button>
					<button
						*ngIf="row.removable"
						lo-button
						variant="link"
						size="sm"
						type="button"
						(click)="askRemove(row)"
					>
						<lo-icon name="trash"></lo-icon>
						Remove
					</button>
				</div>
			</ng-container>

			<app-brand-profile-form
				*ngIf="editingId === row.brand.id"
				[brand]="editingBrand"
				[createSource]="row.isAccount ? 'registration' : 'settings'"
				[canEditIdentity]="!row.isAccount || canEditAccountBrand"
				(saved)="onSaved($event)"
				(cancelled)="cancelEdit()"
			></app-brand-profile-form>
		</div>
	</div>
</lo-card>
